import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */
import { RawHTML } from '@wordpress/element';
import { children as childrenSource } from '@wordpress/blocks';
import deprecated from '@wordpress/deprecated';

/**
 * Internal dependencies
 */
import { getMultilineTag } from './utils';
export const Content = ({
  value,
  tagName: Tag,
  multiline,
  ...props
}) => {
  // Handle deprecated `children` and `node` sources.
  if (Array.isArray(value)) {
    deprecated('wp.blockEditor.RichText value prop as children type', {
      since: '6.1',
      version: '6.3',
      alternative: 'value prop as string',
      link: 'https://developer.wordpress.org/block-editor/how-to-guides/block-tutorial/introducing-attributes-and-editable-fields/'
    });
    value = childrenSource.toHTML(value);
  }
  const MultilineTag = getMultilineTag(multiline);
  if (!value && MultilineTag) {
    value = `<${MultilineTag}></${MultilineTag}>`;
  }
  const content = createElement(RawHTML, null, value);
  if (Tag) {
    const {
      format,
      ...restProps
    } = props;
    return createElement(Tag, {
      ...restProps
    }, content);
  }
  return content;
};
//# sourceMappingURL=content.js.map